/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const DISPLAY_CHECK_ERROR_POPUP_MESSAGE =
  'DISPLAY_CHECK_ERROR_POPUP_MESSAGE';
export const DISPLAY_CHECK_SUCCESS_MESSAGE = 'DISPLAY_CHECK_SUCCESS_MESSAGE';
export const DISPLAY_CHECK_LOADING = 'DISPLAY_CHECK_LOADING';
export const SEARCH_CHECK_FROM_DISPLAY = 'SEARCH_CHECK_FROM_DISPLAY';
export const DISPLAY_CHECK_TABLE_DATA = 'DISPLAY_CHECK_TABLE_DATA';
export const DISPLAY_CHECK_REFERNCE_DATA = 'DISPLAY_CHECK_REFERNCE_DATA';
export const DISPLAY_CHECK_SYSTEM_PARAMETER = 'DISPLAY_CHECK_SYSTEM_PARAMETER';
export const CLICK_ON_MAINTAIN_CHECK = 'CLICK_ON_MAINTAIN_CHECK';
